import { FormControlLabel, Switch, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateViewGuttmanChart } from "../../../../../../store/actions/class-marking.actions";

const SwitchGuttmanChart = () => {
  const dispatch = useDispatch();
  const view = useSelector(
    (state) => state?.classMarking.viewGuttmanChart || "general"
  );

  const onChange = (checked) => {
    if (checked) {
      dispatch(updateViewGuttmanChart("general"));
    } else {
      dispatch(updateViewGuttmanChart("learning-continuum"));
    }
  }
  return (
    <div className="flex items-center justify-end w-full">
      <FormControlLabel
        value={view === "general"}
        name="type-guttman-chart"
        className="justify-between"
        control={
          <Switch
            color="primary"
            size="small"
            checked={view === "general"}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={
          <Typography
            variant="inherit"
            color="primary"
            className="text-sm font-bold"
          >
            {view === "general" ? "General view" : "Learning continuum view"}
          </Typography>
        }
        labelPlacement="start"
      />
    </div>
  );
};

export default SwitchGuttmanChart;
